<template>
  <b-container fluid="sm" class="p-5 mt-5 mb-5 bg-light rounded form-container">
    <slot></slot>
  </b-container>
</template>

<script>
export default {
  name: "CardContainer"
};
</script>
